import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl, ValidationErrors } from '@angular/forms';
import { UpgradeModule } from '@angular/upgrade/static';
import { TranslateModule } from '@ngx-translate/core';
import { IbGiftCardsContributionService } from '@src/app/features/pages/contribution/services/ib-gift-cards-contribution/ib-gift-cards-contribution.service';
import { ibGiftContributionCardComponent } from '../ib-gift-cards-contribution-card/ib-gift-cards-contribution-card.component';
import { IbGiftCardsContributionImportComponent } from '../ib-gift-cards-contribution-import/ib-gift-cards-contribution-import/ib-gift-cards-contribution-import.component';
import { IbGiftCardsContributionSenderDataComponent } from '../ib-gift-cards-contribution-sender-data/ib-gift-cards-contribution-sender-data/ib-gift-cards-contribution-sender-data.component';
import { GiftCardsAppConstants } from '@src/app/shared/constants/ib-gift-cards-constants';
import { IbCModalService } from '@shared/modals/services/ib-gift-cards-modal-service/ib-gift-cards-modal.service';
import { ibGiftCardContributionModal } from '@src/app/shared/modals/contribution/ib-gift-cards-simple-contribution-modal/ib-gift-cards-simple-contribution-modal';
import { managementPayLoad } from '@src/app/core/models/contribution.model';
import { ibGiftCardContributionBackModal } from '@src/app/shared/modals/contribution/ib-gift-cards-back-modal/ib-gift-cards-back-modal';
import { IbGiftCardsRedirectionLandingService } from '@shared/services/ib-gift-cards-redirection-landing/ib-gift-cards-redirection-landing.service';
import { AJSGiftCardsDatalayerUtilsService, GiftCardsDatalayerUtilsServiceType } from '@shared/services/upgrades/ib-gift-cards-datalayer-utils-service-bridge.service';
import { GiftCardsSessionStorageService } from '@src/app/core/services/ib-gift-cards-session-storage/gift-cards-session-storage.service';
import { AJSGiftCardsDigitalDataService, GiftCardsDigitalDataServiceType } from '@shared/services/upgrades/ib-gift-cards-digital-data-service-bridge.service';
import { IbGiftCardsContributionInfoComponent } from '../ib-gift-cards-contribution-card-info/ib-gift-cards-contribution-info/ib-gift-cards-contribution-info.component';

                      
@Component({
    selector: 'ib-gift-cards-new-contribution-form',
    templateUrl: './ib-gift-cards-new-contribution-form.component.html',
    standalone: true,
    imports: [CommonModule, UpgradeModule, TranslateModule, ReactiveFormsModule, ibGiftContributionCardComponent, IbGiftCardsContributionInfoComponent, IbGiftCardsContributionImportComponent, IbGiftCardsContributionSenderDataComponent, ibGiftCardContributionBackModal]
})
export class IbGiftCardsNewContributionFormComponent implements OnDestroy {
    form: FormGroup;
    expirationDate;
    isLongPrice;
    amount;
    
    code;
    constructor (
        private fb: FormBuilder,
        public contritubionService: IbGiftCardsContributionService,
        private IbCModalService: IbCModalService,
        private IbGiftCardsRedirectionLandingService: IbGiftCardsRedirectionLandingService,
        private GiftCardsSessionStorageService: GiftCardsSessionStorageService,
        @Inject(AJSGiftCardsDatalayerUtilsService) private DatalayerUtilsService: GiftCardsDatalayerUtilsServiceType,
        @Inject(AJSGiftCardsDigitalDataService) private DigitalDataService: GiftCardsDigitalDataServiceType
    ) {
        this.amount = `${contritubionService.contributionDataResponse.amount} ${contritubionService.contributionDataResponse.currency.symbol}`.replace('.', contritubionService.contributionDataResponse.currency.decimalSeparator).replace(',', contritubionService.contributionDataResponse.currency.decimalSeparator);
         
        this.expirationDate = this.contritubionService.contributionDataResponse?.deliveryDate?.split(' ')[0];
        this.initForm();
        
    }

    initForm = () => {
        this.saveDestiny('REGOTR');
        this.form = this.fb.group({
            giftCardAmount: [null, [Validators.required, this.amountRangeValidator(), this.numericOnlyValidator()]],
            sender: this.fb.group({
                name: [null, [Validators.required, this.amountMinValidator(GiftCardsAppConstants.MIN_FIELD_LENGTH.MIN_LENGTH_NAME), Validators.pattern('^[^0-9*¡!?¿<>ºª|/·@#$%&,;=()_+{}\\[\\]"^€£]*$')]
                ],
                email: [null, [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]]
            })
        });
    };
    saveDestiny = (destiny:string) => {
        this.GiftCardsSessionStorageService.set('giftCardDestiny', destiny);
        let codigoSeguimientoOld:string = this.GiftCardsSessionStorageService.get('TrackingCode');
        const step: string = GiftCardsAppConstants.QUADRIGAM_STEPS.SELECCION;
        let codigoSeguimientoSplit = codigoSeguimientoOld.split('/')[2] = destiny;
        let codigoSeguimientoNew = codigoSeguimientoOld.split('/')[0] + '/' + codigoSeguimientoOld.split('/')[1] + '/' + codigoSeguimientoSplit;
        let userLogged = this.GiftCardsSessionStorageService.get('userLogged');
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(destiny, null, userLogged);
        this.DigitalDataService.addDigitalDataInfo({TrackingCode: codigoSeguimientoNew, Quadrigam: destiny, Step: step});
        this.DatalayerUtilsService.sendDatalayerEvent(GiftCardsAppConstants.DATALAYER_EVENT_TYPES.VIEW);
        this.DigitalDataService.emitViewEvent();
    };

    amountRangeValidator () {
        const min = this.contritubionService.availabilityDataResponse.groupCustomPrice.minAmount;
        const max = this.contritubionService.availabilityDataResponse.groupCustomPrice.maxAmount;
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (value && typeof Number(value.amount) === 'number') {
                if (Number(value.amount) < min) {
                    return { amountTooLow: true };
                }
                if (Number(value.amount) > max) {
                    return { amountTooHigh: true };
                }
            }
            return null;
        };
    }

    amountMinValidator (min) {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (value && typeof (value) === 'string') {
                if (value.length < min) {
                    return { lengthTooLow: true };
                }
            }
            return null;
        };
    }

    numericOnlyValidator () {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if ([null, undefined, ''].includes(value)) {
                return null;
            }
            const str = typeof value === 'object' && value.amount !== undefined ? value.amount : value;
            const isNumeric = /^[0-9]+$/.test(str);

            return isNumeric ? null : { notNumeric: true };
        };
    }
    
    openContributionSummaryModal = () => {
        const data = this.contritubionService.getContributionSummaryModel({amountToContribute: this.form.get('giftCardAmount').value?.amount});
        const modalRef = this.IbCModalService.showGenericComponentModal(ibGiftCardContributionModal);
        let managementPayLoad: managementPayLoad;
        if (modalRef && modalRef.componentInstance) {
            modalRef.componentInstance.model = { data };
        }
        modalRef.result.then(
            (result) => {
                managementPayLoad = this.contritubionService.getManagementPayLoad(this.form);
                this.contritubionService.putManagement(managementPayLoad);
            },
            (reason) => {
            }
        );
    };
    onSubmit = () => {
        this.contritubionService.formIsSubmitted = true;
        if(!this.form.valid) return;
        this.openContributionSummaryModal();   
    };
    cancel = () => {
        const modalRef = this.IbCModalService.showGenericComponentModal(ibGiftCardContributionBackModal);
        modalRef.result.then(
            (result) => {
                this.IbGiftCardsRedirectionLandingService.redirection(this.contritubionService.getParameterByName('market').toLowerCase(), this.contritubionService.getParameterByName('language').toUpperCase());
            },
            (reason) => {
            }
        );
    };
    ngOnDestroy (): void {
        this.contritubionService.formIsSubmitted = false;
    }
    
}
